module.exports = __webpack_public_path__ + "img/1.0c892413.jpg";